export default class Observer {
	constructor(subject) {
		subject.registerObserver(this);

		this.subscribers = [];
	}

	subscribe(subscriber) {
		this.subscribers.push(subscriber);
	}

	unsubscribe(fn) {
		this.subscribers = this.subscribers.filter(function (item) {
			if (item !== fn) {
				return item;
			}
		});
	}

	disconnect() {
		this.subscribers = [];
	}

	notify(data) {
		this.subscribers.forEach((subscriber) => subscriber(data));
	}
}
